import { TextField, Stack } from '@mui/material';
import React from 'react';
import FileUpload from '../fileupload/FileUpload';

export default function GalleryAdmin(props) {
    return (
    <Stack>
        <FileUpload {...props} />
    </Stack>
    );
}
